import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// -------------------------------------------------------------------------- //
export default class extends Component {
	prepare() {
		this.elContainer = this.element
		this.elImage = this.element.querySelector('figure.image')
		// detect the portion of the image that is outside the view
		const offset = this.elImage.offsetHeight - this.elContainer.offsetHeight

		this.tween = gsap.fromTo(
			this.elImage,
			{ y: 0 },
			{
				y: offset,
				duration: 1,
				ease: 'linear',
				scrollTrigger: {
					trigger: this.element,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true,
				},
			},
		)
	}
	mount() {}
	unmount() {
		if (this.tween) {
			this.tween.scrollTrigger.kill()
			this.tween.kill()
		}
	}
}
